import { Typography, Row, Col, Form, Input, Card, Select } from "antd";
import { useEffect, useState } from "react";

const { Text } = Typography;

// ── Status pill ───────────────────────────────────────────────────────────────
const STATUS_CONFIG = {
  0: { label: "None",    color: "#6b7280", bg: "rgba(107,114,128,0.10)" },
  1: { label: "All",     color: "#15CCAE", bg: "rgba(21,204,174,0.10)"   },
  2: { label: "Partial", color: "#f59e0b", bg: "rgba(245,158,11,0.10)"   },
};

const StatusPill = ({ status }) => {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG[0];
  return (
    <span
      style={{
        display: "inline-block",
        padding: "2px 10px",
        borderRadius: 20,
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: 0.5,
        backgroundColor: cfg.bg,
        color: cfg.color,
        border: `1px solid ${cfg.color}33`,
        marginLeft: 8,
        verticalAlign: "middle",
      }}
    >
      {cfg.label}
    </span>
  );
};

const ViewbranchTypeForm = ({
  session,
  setIsLoading,
  cnt,
  apiConfig,
  BOM,
  selectedBranchTypeKey,
}) => {
  const [form] = Form.useForm();
  const [allowedStatus, setAllowedStatus] = useState(null);

  useEffect(() => {
    getBranchTypeById(selectedBranchTypeKey.id);
  }, []);

  const getBranchTypeById = (id) => {
    const url = `${apiConfig.Officetype}/${id}?template=true`;
    const body = { session };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const STATUS_MAP = { None: 0, All: 1, Partial: 2 };
        setAllowedStatus(STATUS_MAP[res?.allowedPaymentTypes] ?? 0);

        form.setFieldsValue({
          name: res?.name || "",
          allowedPaymentTypes: (res?.configuredPaymentTypes || []).filter((item) => item.id != null).map((item) => item.name),
        });
        setIsLoading(false);
      }
    });
  };

  return (
    <Form form={form} layout="vertical" style={{ paddingTop: 20 }}>
      <Card
        style={{ boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)", borderRadius: 20 }}
        title="View Branch Type"
      >
        <Card
          style={{ marginBottom: "2%", boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)" }}
        >
          <Row gutter={24}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="name"
                label={<Text strong>Name</Text>}
                rules={[{ required: true, message: "Required Field" }]}
              >
                <Input
                  placeholder="Enter Branch Name"
                  className="of-bold-disable-input"
                  disabled
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                name="allowedPaymentTypes"
                label={
                  <span>
                    <Text strong>Allowed Payment Types</Text>
                    {allowedStatus !== null && <StatusPill status={allowedStatus} />}
                  </span>
                }
              >
                <Select
                  mode="multiple"
                  placeholder="—"
                  className="of-bold-disable-input"
                  disabled
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Card>
    </Form>
  );
};

export default ViewbranchTypeForm;
